import React from 'react';
import SearchBox from '../../../../components/outline/SearchBox';
import BaseForm from '../../../../components/form/BaseForm';
import Select from '../../../../components/input/Select';
import { setIfNull, setTrim } from '../../../../lib/common';
import Input from '../../../../components/input/Input/Input';
import TextArea from '../../../../components/input/TextArea';
import DateRangePicker from '../../../../components/datePicker/DateRangePicker';
import { _LIST_PAGINATION_MODEL } from '../../../../store/modules/app/models';
import {
  COUPON_ISSUE_HISTORY_LIST_SEARCH_DATA_MODEL,
  COUPON_ISSUE_HISTORY_LIST_SEARCH_OPTION_MODEL,
} from '../../../../store/modules/coupon/models';
import { DATE_FORMAT } from '../../../../constants/service/common/utilConstants';
import './CouponIssueHistoryListSearchBox.scss';
import { MAXIMUM_NUMBER_OF_SEARCH_BOX_USER_ID } from '../../../../constants/service/app/couponConstants';

const CouponIssueHistoryListSearchBox = (props) => {
  const { setData, getList, searchData, adminSelectList } = props;
  const { couponIssueHistoryId, adminIdList, memo, createDate } = searchData;

  return (
    <SearchBox
      className="coupon-issue-history-list-search-box"
      onSearch={() => {
        getList({
          searchOption: searchData,
          pagination: _LIST_PAGINATION_MODEL,
        });
      }}
      onClear={() => {
        getList({
          searchOption: COUPON_ISSUE_HISTORY_LIST_SEARCH_OPTION_MODEL,
          pagination: _LIST_PAGINATION_MODEL,
        });
        setData({
          path: [],
          value: COUPON_ISSUE_HISTORY_LIST_SEARCH_DATA_MODEL,
        });
      }}
    >
      {/*발급 이력 id 검색*/}
      <BaseForm
        label="발급 이력 id"
        content={
          <TextArea
            value={couponIssueHistoryId}
            maxLength={MAXIMUM_NUMBER_OF_SEARCH_BOX_USER_ID}
            onChange={(value) =>
              setData({
                path: ['couponIssueHistoryId'],
                value: setIfNull(setTrim(value)),
              })
            }
            onPressEnter={() =>
              getList({
                searchOption: searchData,
                pagination: _LIST_PAGINATION_MODEL,
              })
            }
          />
        }
      />

      {/*발급한 관리자 검색*/}
      <BaseForm
        label="발급한 관리자"
        content={
          <div className="input-search-wrap">
            <Select
              showSearch
              optionFilterProp="children"
              list={adminSelectList}
              onChange={(value) =>
                setData({
                  path: ['adminIdList'],
                  value,
                })
              }
              mode="multiple"
              defaultValue={adminIdList}
              value={adminIdList}
              isTable={false}
            />
          </div>
        }
      />

      {/*메모 검색*/}
      <BaseForm
        label="메모"
        content={
          <Input
            value={memo}
            onChange={(value) =>
              setData({
                path: ['memo'],
                value: setIfNull(setTrim(value)),
              })
            }
            onPressEnter={() =>
              getList({
                searchOption: searchData,
                pagination: _LIST_PAGINATION_MODEL,
              })
            }
            maxLength={30}
            size="large"
          />
        }
      />

      {/*쿠폰 발급 이력 생성일*/}
      <BaseForm
        label="쿠폰 발급 이력 생성일"
        content={
          <DateRangePicker
            value={createDate}
            format={DATE_FORMAT.YMD_DASH_FORMAT}
            outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
            btnTextFormat={DATE_FORMAT.YMD_DASH_FORMAT}
            onSelect={(value) =>
              setData({
                path: ['createDate'],
                value,
              })
            }
          />
        }
      />
    </SearchBox>
  );
};

export default CouponIssueHistoryListSearchBox;
